import { render, staticRenderFns } from "./SubsidiesSalaryTypeList.vue?vue&type=template&id=843c35f0"
import script from "./SubsidiesSalaryTypeList.vue?vue&type=script&lang=js"
export * from "./SubsidiesSalaryTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports